import PropTypes from 'prop-types'

import Text from 'components/Text'

import { Label as LabelEl, Root } from './Label.style'

const Label = ({ text, children, error }) => {
  return (
    <Root>
      <LabelEl $error={error}>
        <Text size="xs">{text}</Text>
      </LabelEl>
      {children}
    </Root>
  )
}

Label.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
  error: PropTypes.any,
}

Label.defaultProps = {}

export default Label
